var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
export const Success = (_a) => {
    var { color = "#09B188", size } = _a, props = __rest(_a, ["color", "size"]);
    return (React.createElement("svg", { width: size, height: size, viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M28.5846 6.41724C40.8254 6.41724 50.7513 16.3431 50.7513 28.5839C50.7513 40.8247 40.8254 50.7506 28.5846 50.7506C16.3414 50.7506 6.41797 40.8247 6.41797 28.5839C6.41797 16.3431 16.3414 6.41724 28.5846 6.41724Z", stroke: color, strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M21 28.8703L26.5393 34.4073L37.6133 23.3333", stroke: color, strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round" })));
};
//# sourceMappingURL=Success.js.map